import { useState } from 'react';
import { Capacitor } from '@capacitor/core';

function AppleSignInButton({ onAuth, disabled }) {
  const [loading, setLoading] = useState(false);

  // Only show on iOS native (Capacitor)
  if (!Capacitor.isNativePlatform()) return null;

  const handleAppleSignIn = async () => {
    setLoading(true);
    try {
      // eslint-disable-next-line import/no-unresolved
      const { SignInWithApple } = await import(/* webpackIgnore: true */ '@capacitor-community/apple-sign-in');
      const result = await SignInWithApple.authorize({
        clientId: 'app.guthealing.ios',
        redirectURI: 'https://tractapp.ai',
        scopes: 'email name',
      });

      await onAuth({
        identityToken: result.response.identityToken,
        email: result.response.email,
        fullName: {
          givenName: result.response.givenName,
          familyName: result.response.familyName,
        },
      });
    } catch (err) {
      if (err.message && !err.message.includes('1001')) {
        console.error('Apple Sign-In failed:', err);
      }
      // Error 1001 = user cancelled, ignore
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleAppleSignIn}
      disabled={disabled || loading}
      style={{
        width: '100%',
        height: '44px',
        background: '#000',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        opacity: disabled || loading ? 0.5 : 1,
        marginBottom: '10px',
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
        <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
      </svg>
      {loading ? 'Signing in...' : 'Continue with Apple'}
    </button>
  );
}

export default AppleSignInButton;
